import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { TableCell, IconButton, Tooltip } from '@mui/material';
import clsx from 'clsx';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SubRowCellProps } from './types';

const SubRowCell: React.FunctionComponent<SubRowCellProps> = ({
  enabled,
  expanded,
  row,
  classes,
  onClick,
}) => {
  const { t } = useTranslation('common');
  if (!enabled) {
    return null;
  }

  return (
    <TableCell
      className={clsx(classes.actionCell, {
        [classes.cellWithSubRow]: expanded,
      })}
      key={`row_${row.id}_expand`}
    >
      <Tooltip placement='top' title={t(expanded ? 'collapse' : 'expand')}>
        <IconButton data-id={row.id} onClick={onClick} size='small'>
          {expanded ? <ExpandMore /> : <ExpandLess />}
        </IconButton>
      </Tooltip>
    </TableCell>
  );
};

export default memo(SubRowCell);
